import {MetaData} from "@qid/core";
import {Organisation} from "../../organisation";

export class OrganisationRelationship extends MetaData {

    parentOrg: any;
    childOrg: any | Organisation;
    shareAllTemplates: boolean;
    sharedTemplates: any[];

}


